import { API_BASE_URL } from "../urls.api";

export const GET_CUSTOMER_BY_USER_ID = `${API_BASE_URL}/customers/user`;

export const UPDATE_CUSTOMER = `${API_BASE_URL}/customers`;

export const getCustomerServiceContractsByUserIdUrl = (userId?: string) =>
  `${API_BASE_URL}/customers/service-contracts/user${userId ? `?userId=${userId}` : ""}`;

export const getCustomerPhoneUrl = (userId?: string) =>
  `${API_BASE_URL}/customers/customer-phone/user${userId ? `?userId=${userId}` : ""}`;

export const getSubUsersUrl = (customerId: string) =>
  `${API_BASE_URL}/customers/${customerId}/sub-users`;

export const getSubUserUrl = (customerId: string, userId: string) =>
  `${API_BASE_URL}/customers/${customerId}/sub-users/${userId}`;

export const getSubUserRoomsUrl = (customerId: string, userId: string) =>
  `${API_BASE_URL}/customers/${customerId}/sub-users/${userId}/rooms`;

export const getSubUserAssignAllRoomsUrl = (customerId: string, userId: string) =>
  `${API_BASE_URL}/customers/${customerId}/sub-users/${userId}/rooms/assign-all`;

export const getInviteSubUserUrl = (customerId: string) =>
  `${API_BASE_URL}/customers/${customerId}/sub-users/invite`;

export const getResendSubUserInviteUrl = (customerId: string, userId: string) =>
  `${API_BASE_URL}/customers/${customerId}/sub-users/${userId}/resend-invite`;
